// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2PCGd","signatureButtonsRight":"ModalSign_signatureButtonsRight__3sIan"};